import { render, staticRenderFns } from "./CustomerRating.vue?vue&type=template&id=83a1e124&"
import script from "./CustomerRating.vue?vue&type=script&lang=js&"
export * from "./CustomerRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports